export default {
  Title: 'Molecular Select',
  DateCreateFrom: 'Date Created From',
  DateCreateTo: 'To',
  DateReceiveFrom: 'Date Received From',
  DateReceiveTo: 'To',
  PathoNo: 'Patho No.',
  HLN: 'HLN',
  MLCStatus: 'MLC Status',
  PatientName: 'Patient Name',
  ReceivedDate: 'Received Date',
  Sex: 'Sex',
  Status: 'Status',
  Select: 'Select',
  Block: 'Block',
  Find: 'Find',
  BlockNo: 'Block No.',
  SlideNo: 'Slide No',
  SentDate: 'Sent Date',
  SentTo: 'Sent To',
  Remark: 'Remark',
  CreateDate: 'Created Date',
  CreateUser: 'Created User',
  UpdateDate: 'Updated Date',
  UpdateUser: 'Updated User',
  buttonLevel2Save: 'Save',
  buttonLevel2Delete: 'Delete',
  CreateSlide: 'Create Slide',
  Qty: 'Slide Quantity',
  PrintSlide: 'Print Slide',
  HN: 'HN',
  OrderItem: 'Order Item'
}
